import { c as _c } from "react/compiler-runtime";
import { Link as RouterLink } from 'react-router-dom';
/**
 * use this component rather than next/link
 */
const Link = (t0) => {
    const $ = _c(24);
    let children;
    let externalLink;
    let href;
    let incomingPrefetch;
    let incomingRef;
    let onClick;
    let preventDefault;
    let props;
    if ($[0] !== t0) {
        ({ children, href, preventDefault, onClick, externalLink, ref: incomingRef, prefetch: incomingPrefetch, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = externalLink;
        $[3] = href;
        $[4] = incomingPrefetch;
        $[5] = incomingRef;
        $[6] = onClick;
        $[7] = preventDefault;
        $[8] = props;
    }
    else {
        children = $[1];
        externalLink = $[2];
        href = $[3];
        incomingPrefetch = $[4];
        incomingRef = $[5];
        onClick = $[6];
        preventDefault = $[7];
        props = $[8];
    }
    let t1;
    if ($[9] !== href || $[10] !== onClick || $[11] !== preventDefault) {
        t1 = (e) => {
            let selector = `${href}`;
            if (selector.startsWith("#")) {
                if (selector.startsWith("#.")) {
                    selector = selector.substring(1);
                }
                const destination = document.querySelector(selector);
                if (destination) {
                    const topStickies = Array.from(document.querySelectorAll(".top-sticky"));
                    const yOffset = topStickies.reduce(_temp, 0);
                    const y = destination.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    if ("focus" in destination && typeof destination.focus === "function") {
                        destination.focus();
                    }
                    window.scrollTo({ top: y, behavior: "smooth" });
                }
            }
            if (onClick) {
                if (preventDefault) {
                    e.preventDefault();
                }
                onClick(e);
            }
        };
        $[9] = href;
        $[10] = onClick;
        $[11] = preventDefault;
        $[12] = t1;
    }
    else {
        t1 = $[12];
    }
    const handleClick = t1;
    let t2;
    if ($[13] !== handleClick) {
        t2 = (e_0) => {
            if (e_0.key === " " || e_0.key === "Enter") {
                handleClick(e_0);
            }
        };
        $[13] = handleClick;
        $[14] = t2;
    }
    else {
        t2 = $[14];
    }
    const handleKeyUp = t2;
    const ref = typeof incomingRef === "string" ? undefined : incomingRef;
    const prefetch = incomingPrefetch === false ? "none" : "intent";
    let t3;
    if ($[15] !== children || $[16] !== externalLink || $[17] !== handleClick || $[18] !== handleKeyUp || $[19] !== href || $[20] !== prefetch || $[21] !== props || $[22] !== ref) {
        t3 = externalLink ?
            <a href={href} tabIndex={0} target="_blank" rel="noreferrer" onClick={handleClick} onKeyUp={handleKeyUp} {...props} ref={ref}>

      {children}
    </a> :
            <RouterLink to={href} tabIndex={0} onClick={handleClick} onKeyUp={handleKeyUp} prefetch={prefetch} {...props}>

      {children}
    </RouterLink>;
        $[15] = children;
        $[16] = externalLink;
        $[17] = handleClick;
        $[18] = handleKeyUp;
        $[19] = href;
        $[20] = prefetch;
        $[21] = props;
        $[22] = ref;
        $[23] = t3;
    }
    else {
        t3 = $[23];
    }
    return t3;
};
export default Link;
function _temp(acc, elem) { return acc - elem.getBoundingClientRect().height; }
